<div class="letzte-aktionen-wrapper">
    <mat-card class="panel panel--actions">
    <div class="panel-header kiene-table-header">
        <h2>Letzte Aktionen</h2>
        <div class="panel-header__actions">
            <button
                type="button"
                mat-icon-button
                class="panel-header__action"
                [class.panel-header__action--active]="activeZeitraum !== '7d'"
                [matMenuTriggerFor]="zeitraumMenu"
                [matTooltip]="getZeitraumTooltip()"
                [disabled]="loading"
                aria-label="Zeitraum für Letzte Aktionen"
            >
                <mat-icon>date_range</mat-icon>
            </button>
            <button
                type="button"
                mat-icon-button
                class="panel-header__action"
                [matMenuTriggerFor]="spaltenMenu"
                matTooltip="Spalten auswählen"
                aria-label="Spalten auswählen"
            >
                <mat-icon>view_week</mat-icon>
            </button>
            <button
                type="button"
                mat-icon-button
                class="panel-header__action"
                matTooltip="Pässe abgleichen"
                aria-label="Pässe abgleichen"
                (click)="togglePaesseAbgleichen()"
            >
                <mat-icon>barcode_reader</mat-icon>
            </button>
            <button
                type="button"
                mat-icon-button
                class="panel-header__action"
                matTooltip="Daten aktualisieren"
                aria-label="Daten aktualisieren"
                [disabled]="loading"
                (click)="refreshActions()"
            >
                <span class="panel-header__action-inner">
                    <mat-icon *ngIf="!loading">refresh</mat-icon>
                    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                </span>
            </button>
            <button
                *ngIf="canOpenEinstallenShortcut"
                type="button"
                mat-icon-button
                class="panel-header__action"
                matTooltip="Tiere einstallen, ausstallen oder umstallen"
                aria-label="Tiere einstallen, ausstallen oder umstallen"
                (click)="openEinstallenShortcut()"
            >
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <kiene-paesse-abgleichen
        #paesseAbgleichen
        [showToggleButton]="false"
        [letzteAktionenZeitraum]="activeZeitraum"
        (tierlisteIdFound)="onPaesseAbgleichenTierlisteFound($event)"
    ></kiene-paesse-abgleichen>
    <div *ngIf="highlightedTierlisteHint as hint" class="paesse-abgleichen-hint">
        {{ hint }}
    </div>

    <mat-menu #zeitraumMenu="matMenu">
        <button
            mat-menu-item
            *ngFor="let opt of zeitraumOptions"
            (click)="onZeitraumChange(opt.value)"
        >
            <mat-icon>{{ activeZeitraum === opt.value ? 'check' : 'radio_button_unchecked' }}</mat-icon>
            <span>{{ opt.label }}</span>
        </button>
    </mat-menu>

    <mat-menu #spaltenMenu="matMenu">
        <div class="spalten-menu-content" (click)="$event.stopPropagation()">
            <button
                mat-menu-item
                *ngFor="let col of getSpaltenMenuColumns()"
                (click)="$event.stopPropagation(); toggleColumn(col.key)"
            >
                <mat-icon>{{ col.visible ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                <span>{{ col.label }}</span>
            </button>
        </div>
    </mat-menu>

    <div *ngIf="error" class="panel-state panel-state--error">{{ error }}</div>

    <div class="actions-table-block">
        <div
            #actionsTableViewport
            class="kiene-table-container laa-table-scroll"
            [class.laa-table-scroll--loading]="loading"
            tabindex="0"
            role="region"
            aria-label="Letzte Aktionen Tabelle"
            (scroll)="onActionsTableScroll()"
        >
            <div class="actions-table-inner">
                <table id="letzte-aktionen-table" #letzteAktionenTable class="kiene-table actions-table">
            <thead>
                <tr>
                    <th class="actions-table__expand-col mat-header-cell" aria-hidden="true"></th>
                    <th
                        *ngFor="let col of getVisibleColumns()"
                        class="actions-table__col mat-header-cell"
                        [ngClass]="'actions-table__col--' + col.key"
                        [class.actions-table__sortable-header]="isColumnSortable(col.key)"
                        [class.actions-table__sortable-header--active]="activeSortKey === col.key"
                        (click)="sortByColumn(col.key)"
                    >
                        <span class="actions-table__header-label">
                            {{ col.label }}
                            <mat-icon
                                *ngIf="isColumnSortable(col.key)"
                                class="actions-table__header-sort-icon"
                                [class.actions-table__header-sort-icon--active]="activeSortKey === col.key"
                            >
                                {{ getColumnSortIcon(col.key) }}
                            </mat-icon>
                        </span>
                    </th>
                    <th class="actions-table__menu-col mat-header-cell mat-column-options" aria-hidden="true"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="!loading && !error && actions.length === 0" class="actions-table__empty-row">
                    <td [attr.colspan]="getVisibleColumns().length + 2" class="actions-table__empty-cell mat-cell">
                        Noch keine Aktionen vorhanden.
                    </td>
                </tr>
                <ng-container *ngFor="let row of actions; let i = index">
                    <tr
                        class="actions-table__row--clickable"
                        [class.highlighted-tierliste-row]="isHighlightedTierlisteRow(row)"
                        (click)="openDetailDialog(row, $event)"
                        [class.actions-table__row--umstall-pair-start]="isUmstallPairStart(i)"
                        [class.actions-table__row--umstall-pair-end]="isUmstallPairEnd(i)"
                        [class.actions-table__row--tierliste-pair-start]="isTierlisteGroupPairStart(i)"
                        [class.actions-table__row--tierliste-pair-middle]="isTierlisteGroupPairMiddle(i)"
                        [class.actions-table__row--tierliste-pair-end]="isTierlisteGroupPairEnd(i)"
                        [class.actions-table__row--dual-connection]="isDualConnectionHub(i)"
                    >
                        <td class="actions-table__expand-col mat-cell">
                            <button
                                type="button"
                                mat-icon-button
                                class="actions-table__expand-button"
                                (click)="toggleRowExpanded(row, $event)"
                                [attr.aria-expanded]="isRowExpanded(row)"
                                aria-label="Details ein- oder ausklappen"
                            >
                                <mat-icon>{{ isRowExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </button>
                        </td>

                        <ng-container *ngFor="let col of getVisibleColumns()">
                            <td
                                class="actions-table__col mat-cell"
                                [ngClass]="'actions-table__col--' + col.key"
                                [ngSwitch]="col.key"
                            >
                                <ng-container *ngSwitchCase="'aktion'">
                                    <span class="actions-table__aktion-cell">
                                        <mat-icon
                                            *ngIf="showRowImportIndicator(row)"
                                            class="actions-table__aktion-import-icon"
                                            matTooltip="Bereit zum Importieren"
                                            aria-hidden="true"
                                        >
                                            input
                                        </mat-icon>
                                        <span class="actions-table__aktion">{{ getAktionLabel(row.aktion) }}</span>
                                    </span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'aktion_id'">
                                    <span class="actions-table__aktion-id">{{ row.aktion_id ?? '—' }}</span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'status'">
                                    <div class="actions-table__status-content">
                                        <span class="item-chip" [ngClass]="getStatusChipClass(row)">
                                            {{ getStatusLabel(row) }}
                                        </span>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'betrieb'">
                                    <span class="actions-table__betrieb">{{ row.betrieb }}</span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'anzahl_tiere'">
                                    {{ row.anzahl_tiere }}
                                </ng-container>

                                <ng-container *ngSwitchCase="'aktuelle_gruppe'">
                                    <ng-container
                                        *ngIf="shouldShowAktuelleGruppeForRow(row) && getGruppeLinks(row).length; else aktuelleGruppePlain"
                                    >
                                        <ng-container *ngFor="let gruppe of getGruppeLinks(row); let last = last">
                                            <a
                                                [routerLink]="getGruppeDetailLink(gruppe.gruppe_id)"
                                                class="gruppe-link link-animated"
                                                (click)="$event.stopPropagation()"
                                            >
                                                {{ gruppe.bezeichnung }}
                                            </a>
                                            <span *ngIf="!last" class="gruppe-separator">, </span>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #aktuelleGruppePlain>
                                        <span>{{ getLetzteAktionAktuelleGruppeDisplay(row) }}</span>
                                    </ng-template>
                                </ng-container>

                                <ng-container *ngSwitchCase="'herkunft'">
                                    <span
                                        class="herkunft-ziel-cell"
                                        [class.herkunft-ziel-cell--innerhalb]="row.transfer_innerhalb_betrieb"
                                    >
                                        <mat-icon
                                            *ngIf="row.transfer_innerhalb_betrieb"
                                            class="herkunft-ziel-icon herkunft-ziel-icon--innerhalb"
                                            matTooltip="Transfer innerhalb Ihrer Betriebe"
                                        >
                                            swap_horiz
                                        </mat-icon>
                                        <mat-icon
                                            *ngIf="showHerkunftZielbetriebIcon(row)"
                                            class="herkunft-ziel-icon"
                                            [ngClass]="getHerkunftZielbetriebIconClass(row)"
                                            [matTooltip]="getHerkunftZielbetriebTooltip(row)!"
                                        >
                                            {{ getHerkunftZielbetriebIcon(row) }}
                                        </mat-icon>
                                        <span class="herkunft-ziel-text">{{ row.herkunft }}</span>
                                    </span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'datum'">
                                    <span class="actions-table__date">{{ row.datum | date: 'dd.MM.yyyy' }}</span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'abschnitt'">
                                    <span>{{ getLetzteAktionAbschnittDisplay(row) }}</span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'kommentar'">
                                    <span
                                        class="actions-table__kommentar"
                                        [class.actions-table__kommentar--auto]="isAutomatischerKommentar(row)"
                                        [matTooltip]="row.kommentar || ''"
                                    >
                                        {{ row.kommentar || '—' }}
                                    </span>
                                </ng-container>
                            </td>
                        </ng-container>

                        <td class="actions-table__menu mat-cell mat-column-options" (click)="$event.stopPropagation()">
                            <kiene-letzte-aktionen-tierliste-menu
                                *ngIf="showTierlisteMenu(row)"
                                [tierlisteId]="row.tierliste_id"
                                [listenstatusId]="row.listenstatus_id"
                                [menuAktion]="row.aktion"
                                [mode]="getTierlisteMenuMode(row)"
                                (continueScans)="continueDirectScan(row)"
                                (directScanListeAbschliessen)="listeAbschliessenDirectScan(row)"
                                (changed)="onTierlisteMenuChanged()"
                            ></kiene-letzte-aktionen-tierliste-menu>
                        </td>
                    </tr>

                    <tr
                        class="actions-table__detail-row"
                        [class.actions-table__detail-row--expanded]="isRowExpanded(row)"
                        [class.actions-table__detail-row--umstall-bridge]="showUmstallDetailBridge(row, i)"
                        [class.actions-table__detail-row--tierliste-bridge]="showTierlisteGroupDetailBridge(row, i)"
                        [class.actions-table__detail-row--dual-connection-bridge]="showDualConnectionDetailBridge(row, i)"
                    >
                        <td class="actions-table__detail-spacer mat-cell">
                            <div class="actions-table__detail-anim" [@detailExpand]="getDetailExpandState(row)">
                                <div class="actions-table__detail-spacer-inner"></div>
                            </div>
                        </td>
                        <ng-container *ngFor="let col of getVisibleColumns()">
                            <td
                                class="actions-table__detail-cell actions-table__col mat-cell"
                                [ngClass]="'actions-table__col--' + col.key"
                            >
                                <div class="actions-table__detail-anim" [@detailExpand]="getDetailExpandState(row)">
                                    <div class="actions-table__detail-cell-content">
                                        <ng-container *ngIf="getExpandedDetailCell(row, col) as detail">
                                            <span class="actions-table__detail-label" [attr.title]="detail.label">{{
                                                detail.label
                                            }}</span>
                                            <span class="actions-table__detail-value" [attr.title]="detail.value">{{
                                                detail.value
                                            }}</span>
                                        </ng-container>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <td class="actions-table__menu mat-cell mat-column-options">
                            <div class="actions-table__detail-anim" [@detailExpand]="getDetailExpandState(row)">
                                <div *ngIf="isMetricsLoadingRow(row)" class="actions-table__detail-loading">
                                    Werte werden geladen...
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
                </table>
            </div>
            <div *ngIf="loading" class="actions-table__loading-overlay" aria-hidden="true">
                <mat-spinner diameter="32"></mat-spinner>
            </div>
        </div>

        <div *ngIf="showPaginator" class="panel-pagination">
            <mat-paginator
                [length]="totalCount"
                [pageIndex]="pageIndex"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                showFirstLastButtons
                (page)="onPageChange($any($event))"
            ></mat-paginator>
        </div>
    </div>

    <!-- Same pattern as kiene-table (/gruppen/aktuelle): fixed bar mounted to document.body -->
    <div
        #bottomScrollbar
        class="kiene-horizontal-scrollbar"
        [class.hidden]="!showHorizontalScrollbar"
        (scroll)="onBottomScrollbarScroll()"
    >
        <div class="kiene-horizontal-scrollbar-content" [style.width.px]="horizontalScrollWidth"></div>
    </div>
    </mat-card>
</div>
